import React from 'react';
import withIcon from '../utilities/withIcon';

const IconKeyboard = () => {
  return (
    <g>
      <path d="m15.1594 2.5762h-14.3188a.7.7 0 0 0 -.7.7v9.4473a.7.7 0 0 0 .7.7h14.3188a.7.7 0 0 0 .7-.7v-9.4471a.7.7 0 0 0 -.7-.7002zm-.7 9.4473h-12.9186v-8.0469h12.9184z" />
      <circle cx="3.7196" cy="5.8834" r=".7916" />
      <circle cx="6.5092" cy="5.8834" r=".7916" />
      <circle cx="9.2988" cy="5.8834" r=".7916" />
      <circle cx="12.0884" cy="5.8834" r=".7916" />
      <circle cx="5.175" cy="8.1272" r=".7916" />
      <circle cx="7.9646" cy="8.1272" r=".7916" />
      <circle cx="10.7543" cy="8.1272" r=".7916" />
      <path d="m11.44 9.7661h-7.033a.625.625 0 0 0 0 1.25h7.033a.625.625 0 0 0 0-1.25z" />
    </g>
  );
};

export default withIcon(IconKeyboard);
